export enum IncomeSource {
    Retirement  = "Retirement",
    Pension = "Pension",
    SocialSecurity = "Social Security",
    Alimony = "Alimony",
    ChildSupport = "Child Support",
    Disability = "Disability",
    Trust = "Trust",
    Other = "Other"
}